





















































































































































































































































































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { Editor, BubbleMenu } from '@tiptap/vue-2';
import TableActionbar from '@/components/question-editor/editor-extensions/nodes/new/node-table/Action.vue';
import Icon from '@/main-components/common/Icon.vue';
import Modal from '@/main-components/common/modal/Modal.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import ImageUploadStore, {
  ImageUploadInterface,
  UploadFolderName,
} from '@/resource/file-upload/file-upload.store';
import EditorLanguage from './EditorLanguage.vue';
import { NodeTypes } from '@/components/question-editor/editor-extensions/nodes/nodes';
import isEmptyObject from '@/utils/common/is-object-empty';

@Component({
  components: {
    BubbleMenu,
    TableActionbar,
    Icon,
    Modal,
    MainButton,
    EditorLanguage,
  },
})
export default class EditorOption extends Vue {
  @Prop()
  editor!: Editor;

  @Prop()
  isBubbleMenu: boolean;

  @Prop()
  isAdmin: boolean;

  @Inject('colorBrandDarkSecondary')
  colorBrandDarkSecondary!: string;

  isTableOption = false;
  imageUploadStore: ImageUploadInterface = ImageUploadStore;

  openUploadImageModal: any = null;
  closeUploadImageModal: any = null;
  imageUpload: any | null = null;

  openUploadImageModalAdd(openModal: any) {
    this.openUploadImageModal = openModal;
  }
  closeUploadImageModalAdd(closeModal: any) {
    this.closeUploadImageModal = closeModal;
  }

  addImage() {
    this.imageUpload = null;
    this.openUploadImageModal && this.openUploadImageModal();
  }

  handleFileUpload(files: any) {
    this.imageUpload = files[0];

    const isImageFile =
      (this.imageUpload &&
        this.imageUpload.type &&
        this.imageUpload.type.split('/')[0].trim() === 'image') ||
      false;

    if (!isImageFile) {
      this.$toasted.global.mainToast({
        message: 'Please choose image file only',
      });
      this.imageUpload = null;
    }
  }

  async uploadImage() {
    if (!this.imageUpload) {
      this.$toasted.global.mainToast({
        message: 'Please choose image first',
      });
      return;
    }

    if (this.imageUpload.size > 0.5e7) {
      this.$toasted.global.mainToast({
        message: 'Error: File is more than 5mb',
      });
      this.imageUpload = null;
      return;
    }

    await this.imageUploadStore.imageUpload({
      files: [this.imageUpload],
      folderName: UploadFolderName.questionBank,
    });

    if (this.imageUploadStore.error) {
      this.$toasted.global.mainToast({
        message: this.imageUploadStore.error.message,
      });
      return;
    }

    if (this.imageUploadStore.response) {
      this.imageUpload = null;
      this.editor
        .chain()
        .focus()
        .setImage({ src: this.imageUploadStore.response.url })
        .run();

      this.closeUploadImageModal && this.closeUploadImageModal();
    }
  }

  truncateFileName(text: string) {
    const limit = 20;
    if (text.length <= limit) {
      return text;
    }
    return text.slice(0, limit / 2) + '...' + text.slice(-limit / 2);
  }

  toggleTableOption() {
    this.editor
      .chain()
      .focus((this.isTableOption = !this.isTableOption))
      .run();
  }

  addQuestionInQuestion() {
    if (!this.editor) return;

    const isSinkListItem = this.editor.commands.sinkListItem(
      NodeTypes.ListItem,
    );

    if (isSinkListItem) {
      //
      const isOrderedList = !isEmptyObject(
        this.editor.getAttributes(NodeTypes.OrderedList),
      );

      const isAlphabetList = !isEmptyObject(
        this.editor.getAttributes(NodeTypes.AlphabetList),
      );

      const isRomanList = !isEmptyObject(
        this.editor.getAttributes(NodeTypes.RomanList),
      );

      if (isOrderedList) {
        this.editor.commands.toggleList(
          NodeTypes.AlphabetList,
          NodeTypes.ListItem,
        );
      }

      if (isAlphabetList) {
        this.editor.commands.toggleList(
          NodeTypes.RomanList,
          NodeTypes.ListItem,
        );
      }

      if (isRomanList) {
        this.editor.commands.toggleList(
          NodeTypes.AlphabetList,
          NodeTypes.ListItem,
        );
      }
    }
  }

  closeEditor() {
    this.$emit('closeEditor');
  }
}
